// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.col-12 > .p-4 {
  border: 1px solid var(--surface-100);
}

.flex-grow-1 {
  display: grid;
  place-content: center;
}

.discord .flex-column > *:last-child {
  width: -moz-fit-content;
  width: fit-content;
  height: 400px;
}
.discord .flex-column > *:last-child iframe {
  width: 100%;
  height: 100%;
  position: absolute;
  inset: 0;
}

.youtube .flex-grow-1 > * {
  text-indent: 0px;
  margin: 0px;
  padding: 0px;
  background: transparent;
  border-style: none;
  float: none;
  line-height: normal;
  font-size: 1px;
  vertical-align: baseline;
  display: inline-block;
  background: white;
  padding: 1rem;
}
.youtube .flex-grow-1 > * iframe {
  position: static;
  top: 0px;
  width: 169px;
  margin: 0px;
  border-style: none;
  left: 0px;
  visibility: visible;
  height: 48px;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/home/components/socials/socials.component.scss"],"names":[],"mappings":"AAAA;EACE,oCAAA;AACF;;AAEA;EACE,aAAA;EACA,qBAAA;AACF;;AAEA;EACE,uBAAA;EAAA,kBAAA;EACA,aAAA;AACF;AACE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;AACJ;;AAGA;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA;EACA,wBAAA;EACA,qBAAA;EACA,iBAAA;EACA,aAAA;AAAF;AAEE;EACE,gBAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,mBAAA;EACA,YAAA;AAAJ","sourcesContent":[".col-12 > .p-4 {\r\n  border: 1px solid var(--surface-100);\r\n}\r\n\r\n.flex-grow-1 {\r\n  display: grid;\r\n  place-content: center;\r\n}\r\n\r\n.discord .flex-column > *:last-child {\r\n  width: fit-content;\r\n  height: 400px;\r\n\r\n  iframe {\r\n    width: 100%;\r\n    height: 100%;\r\n    position: absolute;\r\n    inset: 0;\r\n  }\r\n}\r\n\r\n.youtube .flex-grow-1 > * {\r\n  text-indent: 0px;\r\n  margin: 0px;\r\n  padding: 0px;\r\n  background: transparent;\r\n  border-style: none;\r\n  float: none;\r\n  line-height: normal;\r\n  font-size: 1px;\r\n  vertical-align: baseline;\r\n  display: inline-block;\r\n  background: white;\r\n  padding: 1rem;\r\n\r\n  iframe {\r\n    position: static;\r\n    top: 0px;\r\n    width: 169px;\r\n    margin: 0px;\r\n    border-style: none;\r\n    left: 0px;\r\n    visibility: visible;\r\n    height: 48px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
